const MEDIA_ASSETS_COLLECTION = "media_assets";

const populateSnapshots = (snapshots) => {
  const docs = [];
  snapshots.forEach((snap) => {
    docs.push(extractSnapshotData(snap));
  });
  return docs;
};

const extractSnapshotData = (snap) => {
  if (!snap.exists) {
    return null;
  }

  return {
    id: snap.id,
    ...snap.data()
  };
};

function MediaAssetsMixin(firebase) {
  return {
    async getMediaAssetWithId(mediaAssetsId) {
      return await this.collection(MEDIA_ASSETS_COLLECTION)
        .doc(mediaAssetsId)
        .get()
        .then(extractSnapshotData);
    },
    async getMediaAssetWithCampaignId(campaignId) {
      return await this.collection(MEDIA_ASSETS_COLLECTION)
        .where("campaignId", "==", campaignId)
        .get()
        .then(populateSnapshots);
    },
    async getMediaAssetWithAdCreativeId(adCreativeId) {
      return await this.collection(MEDIA_ASSETS_COLLECTION)
        .where("adCreativeId", "==", adCreativeId)
        .get()
        .then(populateSnapshots);
    },
    async createMediaAsset({ id, ...data }) {
      const ref = await this.collection(MEDIA_ASSETS_COLLECTION).add(data);
      const mediaAssets = {
        id: ref.id,
        ...data
      };
      return mediaAssets;
    },
    /**
     * Duplicates media assets by creating new media assets with the same data
     *
     * @param {string[]} mediaAssetIds
     * @returns {Promise<object[]>} Returns an array of duplicated media assets
     */
    async duplicateMediaAssets(mediaAssetIds) {
      const cleanMediaAssetIds = mediaAssetIds.filter((id) => id);
      const mediaAssets = await this.getMediaAssetsByIds(cleanMediaAssetIds);

      const sortedMediaAssets = cleanMediaAssetIds
        .map((id) => mediaAssets.find((mediaAsset) => mediaAsset.id === id))
        .filter((mediaAsset) => mediaAsset);

      return await this.saveMediaAssets(sortedMediaAssets);
    },
    async saveMediaAssets(mediaAssets = []) {
      const batch = firebase.firestore().batch();
      const newMediaAssets = [];
      mediaAssets.forEach(({ id, ...mediaAsset }) => {
        const mediaAssetsRef = this.collection(MEDIA_ASSETS_COLLECTION).doc();
        batch.set(mediaAssetsRef, mediaAsset);
        newMediaAssets.push({ ...mediaAsset, id: mediaAssetsRef.id });
      });
      await batch.commit();
      return newMediaAssets;
    },
    async deleteMediaAssetById(mediaAssetId) {
      return this.collection(MEDIA_ASSETS_COLLECTION).doc(mediaAssetId).delete();
    },
    async deleteMediaAssetsByCampaignId(campaignId) {
      const batch = firebase.firestore().batch();
      const mediaAssets = await this.collection(MEDIA_ASSETS_COLLECTION)
        .where("campaignId", "==", campaignId)
        .get();
      mediaAssets.forEach((doc) => {
        batch.delete(doc.ref);
      });
      return batch.commit();
    },
    async updateMediaAsset(mediaAssetsId, { id, ...mediaAssetsData }) {
      return await this.collection(MEDIA_ASSETS_COLLECTION)
        .doc(mediaAssetsId)
        .set(mediaAssetsData, { merge: true });
    },

    //* Firebase limitation to a maximum of 10 ids
    async getMediaAssetsByIds(mediaAssetsIds) {
      return await this.collection(MEDIA_ASSETS_COLLECTION)
        .where(firebase.firestore.FieldPath.documentId(), "in", mediaAssetsIds)
        .get()
        .then(populateSnapshots);
    }
  };
}

module.exports = MediaAssetsMixin;
